<template>
  <v-app-bar
    app
    class="primary elevation-0"
    dark
  >
    <v-toolbar-title>
      <span
        v-if="cashRegister"
        class="mr-4"
      >
        <v-icon
          class="mr-1 mt-n1"
          small
        >far fa-cash-register</v-icon>
        {{ cashRegister.description }}
      </span>
      <template v-if="user">
        <v-icon
          small
          class="mr-1 mt-n1"
        >far fa-user</v-icon>
        {{ user.screen_name }}
      </template>
      <div class="d-inline-flex ml-10">
        <img
          class="mr-2"
          src="/static/images/18+.png"
          height="22"
          width="22"
          style="position:relative;top:4px;"
        >
        {{ $t('Born before: {0}', [eighteenYearsAgo]) }}
      </div>
    </v-toolbar-title>

    <v-spacer />
    <catalog-switcher v-if="showCatalogSwitcher" />
    <v-divider
      v-if="showCatalogSwitcher"
      class="ml-5 mr-3"
      vertical
    />
    <v-toolbar-items
      v-if="isAuthenticated"
      class="hidden-sm-and-down"
    >
      <v-btn
        v-if="isQzTrayInstalled && isPrinterConfigured"
        text
        @click="openDrawerCheck"
      >
        <v-icon
          left
          small
        >fal fa-cash-register</v-icon>
        {{ $t('Open Drawer') }}
      </v-btn>
      <v-btn
        v-else
        text
        readonly
        class="white--text"
      >
        <v-icon
          small
          class="mr-2"
        >fal fa-exclamation-triangle</v-icon>
        {{ $t('No {0}', [$t('Printer')]) }}
      </v-btn>
      <v-btn
        :to="'/logout'"
        text
      >
        <v-icon
          left
          small
        >fal fa-sign-out</v-icon>
        {{ $t('Logout') }}
      </v-btn>
    </v-toolbar-items>
    <drawer-opener ref="drawer" />
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DrawerOpener from '@/components/DrawerOpener'
import CatalogSwitcher from '@/components/CatalogSwitcher'
import moment from 'moment'

export default {
  name: 'AppToolbar',

  components: {
    DrawerOpener,
    CatalogSwitcher
  },

  computed: {
    ...mapGetters('AUTH', ['isAuthenticated', 'user']),
    ...mapGetters(['cashRegister', 'locale', 'isPrinterConfigured']),
    ...mapState(['isQzTrayInstalled', 'printer']),
    showCatalogSwitcher () {
      return this.$route.name === 'ProductsIndex' || this.$route.name === 'VapeVault'
    },
    eighteenYearsAgo () {
      const now = moment()
      // Subtract 18 years from the current date using Moment.js
      const eighteenYearsAgoDate = now.subtract(18, 'years')
      return eighteenYearsAgoDate.format('D MMMM YYYY')
    }
  },

  methods: {
    openDrawerCheck () {
      if (this.$route.name === 'CashRegistersOpenClose') {
        this.openDrawer()
      } else {
        this.openDrawerPrompt()
      }
    },
    openDrawerPrompt () {
      this.$refs.drawer.showPromptBeforeOpen()
    },
    openDrawer () {
      this.$refs.drawer.openDrawer()
    }
  }
}
</script>
